import axios from '../lib/axios';
import {
  CREATE_POPUP,
  DELETE_POPUP,
  FIND_MANY_POPUP,
  UPDATE_POPUP,
} from '../lib/endpoints/advertise';

interface PopupSlideProps {
  page?: number;
  limit?: number;
  merchant?: string;
  type?: string;
}
export interface InputCreatePopup {
  merchant?: string;
  productId?: string;
  promotionTagId?: string;
  subCategoryId?: string;
  image?: File;
  type?: string;
  link?: string;
  description?: string;
  isActive?: boolean;
  startDate?: string;
  endDate?: string;
}
export interface InputUpdatePopup {
  id: string;
  image: File;
  startDate: string;
  endDate: string;
  isActive?: boolean;
}

export const getAllPopupSlideService = async ({ page, limit, type }: PopupSlideProps) => {
  try {
    const queryParams: Record<number, string> = {
      ...(page !== undefined ? { page: page } : {}),
      ...(limit !== undefined ? { limit: limit } : {}),
    };

    const queryString = new URLSearchParams(queryParams).toString();
    const res = await axios.post(`${FIND_MANY_POPUP}?${queryString}`, {
      type: type,
    },{
      headers:{
        'Accept-Language' : 'lo'
      }
    });
    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const createPopupService = async (input: InputCreatePopup) => {
  try {
    const formData = new FormData();
    for (const [key, value] of Object.entries(input)) {
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(`${key}[]`, item));
      } else if (value) {
        formData.append(key, value);
      }
    }

    const response = await axios.post(CREATE_POPUP, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });

    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const updatePopupService = async (input: InputUpdatePopup, id: string) => {
  try {
    const formData = {
      image: input.image,
      startDate: input.startDate,
      endDate: input.endDate,
      isActive: input.isActive
    };
    const response = await axios.patch(`${UPDATE_POPUP}${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });

    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const deletePopupService = async (Id: string): Promise<void> => {
  await axios.delete(DELETE_POPUP + Id);
};
